import React from 'react';
import Button from '../../../components/ui/Button';

const FormActions = ({
  onSubmit,
  onCancel,
  isSubmitting,
  isEditMode,
  submitError
}) => {
  return (
    <div className="bg-white rounded-lg border border-border shadow-sm p-6">
      {/* Submit Error */}
      {submitError && (
        <div className="mb-4 bg-red-50 border border-red-200 rounded-lg p-3">
          <div className="flex items-start space-x-2">
            <svg className="w-4 h-4 text-red-600 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <div className="text-sm text-red-800">
              <p className="font-medium">{submitError}</p>
            </div>
          </div>
        </div>
      )}

      {/* Action Buttons */}
      <div className="flex flex-col sm:flex-row items-center justify-end space-y-3 sm:space-y-0 sm:space-x-3">
        <Button
          variant="outline"
          onClick={onCancel}
          disabled={isSubmitting}
          className="w-full sm:w-auto"
        >
          Cancelar
        </Button>
        
        <Button
          onClick={onSubmit}
          loading={isSubmitting}
          iconName={isEditMode ? "Save" : "UserPlus"}
          iconPosition="left"
          className="w-full sm:w-auto"
        >
          {isEditMode ? 'Atualizar usuário' : 'Criar usuário'}
        </Button>
      </div>

      {/* Form Summary */}
      <div className="mt-6 pt-4 border-t border-border">
        <div className="text-xs text-muted-foreground">
          <p className="mb-1">
            {isEditMode 
              ? 'As alterações serão aplicadas imediatamente ao salvar.' :'Após criada, a conta ficará ativa e pronta para acesso.'
            }
          </p>
          {!isEditMode && (
            <p>
              Verifique se todas as informações estão corretas antes de prosseguir.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default FormActions;